import React, { Component } from "react";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import "dayjs/locale/nl";
import customParseFormat from "dayjs/plugin/customParseFormat";

class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = { modal: false, isLoading: false, data: [] };
  }

  createMarkup(txt) {
    return { __html: txt };
  }
  render() {
    const delayedColor = () => {
      dayjs.extend(customParseFormat);
      const days = dayjs(
        this.props.notification.order_delivery_moment,
        "DD-MM-YYYY"
      ).diff(dayjs(this.props.notification.order_date, "DD-MM-YYYY"), "days");
      switch (true) {
        case days == 1:
          return "text-warning";
        case days == 2:
          return "text-danger";
        case days >= 3:
          return "text-danger";
        default:
          return "text-success";
      }
    };

    return (
      <Link
        to={"/producten/details/" + this.props.notification.orderrow_art_id}
        className={"Delayed"}
      >
        <div className="DelayedPhoto">
          <img src={this.props.notification.image} alt="" />
        </div>
        <div>
          <div className="DelayedTitle">
            {this.props.notification.orderrow_quantity} x{" "}
            {this.props.notification.orderrow_name}
          </div>
          <div className="DelayedSubs">
            <div className={`DelayedCurrent ${delayedColor()}`}>
              {this.props.notification.order_delivery_moment}
            </div>
            <div className="DelayedTarget">
              (o.l.d. {this.props.notification.order_date})
            </div>
          </div>
        </div>
        <div>
          <i className="fa fa-regular fa-chevron-right go"></i>
        </div>
      </Link>
    );
  }
}

export default Notification;
